// Brand
const brand_1 = "var(--primary-color)";
const brand_2 = "#59a5f5";
const brand_3 = "#8ed1fc";

// Neutral
const brandNeutral_1 = "#00BFFF";
const brandNeutral_2 = "#00619a";

//Text
const text_1 = "#333333";
const text_2 = "#5c5c5c";

// Background
const bg_1 = "#FFFFFF";
const bg_2 = "#f5f5f5";
const bg_3 = "#cccccc";
// Danger
const danger_1 = "#A91700";
const danger_2 = "#D34A35";
const danger_3 = "#FBDBD5";
const danger_4 = "#F8EEEC";

// Warning
const warning_1 = "#8F5300";
const warning_2 = "#BD8A00";
const warning_3 = "#FFF7E5";

// Success
const success_1 = "#296804";
const success_2 = "#479915";
const success_3 = "#EDF2E8";

const variableConstants = {
  fontSize: {
    xxlarge: "28px",
    xlarge: "24px",
    medium: "20px",
    small: "16px",
    xsmall: "14px",
    xxsmall: "12px",
  },
  fontWeight: {
    normal: 400,
    semiBold: 600,
    bold: 700,
  },
  lineHeight: {
    Xxlarge: 1.2857142857,
    Xlarge: 1.3333333333,
    Medium: 1.4,
    Small: 1.5,
    Xsmall: 1.7142857143,
  },
  border: {
    width: "1px",
    widthLarge: "2px",
    widthXLarge: "4px",
  },
  borderRadius: {
    none: "0",
    small: ".25rem",
    base: ".375rem",
    baseInner: ".25rem",
    largeInner: ".5rem",
    large: ".75rem",
    full: "50%",
  },
  colors: {
    brand: {
      1: brand_1,
      2: brand_2,
      3: brand_3,
    },
    neutral: {
      1: brandNeutral_1,
      2: brandNeutral_2,
      white: "#ffffff",
    },

    danger: {
      1: danger_1,
      2: danger_2,
      3: danger_3,
      4: danger_4,
    },
    warning: {
      1: warning_1,
      2: warning_2,
      3: warning_3,
    },
    success: {
      1: success_1,
      2: success_2,
      3: success_3,
    },
    background: {
      white: bg_1,
      lightGray: bg_2,
      gray: bg_3,
    },
    text: {
      default: text_1,
      light: text_2,
      brand: brand_2,
      brandDark: brand_1,
      danger: danger_1,
      warning: warning_1,
      success: success_1,
    },
  },

  transitions: {
    hover: "0.25s cubic-bezier(0.165, 0.84, 0.44, 1) 0s",
    overlay: "0.35s cubic-bezier(0.165, 0.84, 0.44, 1) 0s",
    slide: "0.45s cubic-bezier(0.165, 0.84, 0.44, 1) 0s",
  },
  spacing: {
    none: "0rem",
    xxsmall: ".25rem",
    xsmall: ".5rem",
    small: ".75rem",
    medium: "1rem",
    large: "1.5rem",
    xlarge: "2rem",
    xxlarge: "2.5rem",
  },
};

export default variableConstants;
